import { gql } from 'react-apollo';

export const getEvangelists = gql`
  query getEvangelists {
    evangelists {
      id
      name
      email
      passwordCreated: password_created
      photo {
        small
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/evangelists/queries/getEvangelists.js